export { SkillCommunication as default } from './SkillCommunication';
